(() => {
  const root = document.querySelector('[data-frizi-pack-sticky]');
  const contextApi = window.FriziPackContext;
  if (!root || !contextApi) return;

  const title = root.querySelector('[data-frizi-pack-sticky-title]');
  const progress = root.querySelector('[data-frizi-pack-sticky-progress]');
  const thumbnails = root.querySelector('[data-frizi-pack-sticky-thumbnails]');
  const resume = root.querySelector('[data-frizi-pack-sticky-resume]');

  const safeImageUrl = (value) => {
    if (!value) return '';
    try {
      const url = new URL(value, window.location.origin);
      return ['http:', 'https:'].includes(url.protocol) ? url.href : '';
    } catch (error) {
      return '';
    }
  };

  const renderThumbnails = (posters) => {
    thumbnails.replaceChildren();
    posters.forEach((poster) => {
      const thumbnail = document.createElement('span');
      thumbnail.className = 'frizi-pack-sticky__thumbnail';
      const imageUrl = safeImageUrl(poster.image);

      if (!imageUrl) {
        thumbnail.classList.add('frizi-pack-sticky__thumbnail--fallback');
        thumbnail.setAttribute('aria-hidden', 'true');
      } else {
        const image = document.createElement('img');
        image.src = imageUrl;
        image.alt = poster.title || 'Affiche sélectionnée';
        image.decoding = 'async';
        image.addEventListener('error', () => {
          thumbnail.classList.add('frizi-pack-sticky__thumbnail--fallback');
          image.remove();
        }, { once: true });
        thumbnail.append(image);
      }
      thumbnails.append(thumbnail);
    });
  };

  const render = () => {
    const context = contextApi.read();
    if (!context) {
      root.hidden = true;
      return;
    }

    const count = context.selectedPosters.length;
    const complete = count === context.requiredPosters;
    title.textContent = context.title || 'PACK EN COURS';
    progress.textContent = complete
      ? `✓ ${count}/${context.requiredPosters} — PACK COMPLET`
      : `${count}/${context.requiredPosters} affiches`;
    progress.classList.toggle('is-complete', complete);
    renderThumbnails(context.selectedPosters);
    root.hidden = false;
  };

  const getResumeUrl = (context) => {
    const handle = context.selectedPosters[0]?.handle;
    if (handle) {
      const rootUrl = window.routes?.root_url || '/';
      const url = new URL(`${rootUrl.replace(/\/$/, '')}/products/${encodeURIComponent(handle)}`, window.location.origin);
      url.searchParams.set('frizi_resume_pack', '1');
      return url.href;
    }
    return context.shopUrl || window.routes?.all_products_collection_url || '/collections/all';
  };

  resume?.addEventListener('click', () => {
    const context = contextApi.read();
    if (!context) return;

    if (document.querySelector('[data-bundle-modal]')) {
      window.dispatchEvent(new CustomEvent('frizi:pack-resume'));
      return;
    }

    window.location.assign(getResumeUrl(context));
  });

  window.addEventListener(contextApi.changeEvent, render);
  window.addEventListener('storage', (event) => {
    if (event.key === contextApi.key) render();
  });
  render();
})();
